import { action, makeAutoObservable, flow } from 'mobx'
import AsyncStorage from '@react-native-community/async-storage'
import api from '../api'
import _ from 'lodash'

class FeedStore {
    feeds = []
    feedCount = 0

    constructor() {
        makeAutoObservable(this)
    }

    listFeeds = flow(function* (skip) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.listFeeds(token, limit = 20, skip)
            const { feeds, count } = response.data
            this.feeds = feeds
            this.feedCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    listMoreFeeds = flow(function* (skip) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.listFeeds(token, limit = 20, skip)
            const { feeds, count } = response.data
            this.feeds = _.union(this.feeds, feeds)
            this.feedCount = count
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    getFeed = flow(function* (feedId) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.getFeed(token, feedId)
            return Promise.resolve(response.data)
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })

    updateFeedStatus = flow(function* (feedId, status) {
        try {
            const token = yield AsyncStorage.getItem('token')
            const response = yield api.updateFeedStatus(token, feedId, status)
            if (status == 'DELETED') {
                this.feeds = this.feeds.filter((f) => { return f._id !== feedId })
            }
            const index = this.feeds.findIndex((f) => { return f._id == feedId })
            this.feeds[index] = response.data
            return Promise.resolve()
        }
        catch (error) {
            console.log(error)
            return Promise.reject(error.response.data.errorCodes)
        }
    })
}

export default new FeedStore()